<template>
  <div class="vs-row" style="margin-top: 5px">
    <toggle-switch @change="onEngineSwitch($event.value)" :options="myOptions" :disabled="false" v-model="engineSwitch"
                   style="float: left"/>
    <span style="font-weight: bold;color:black;margin-left: 5px;margin-top: 5px;float: left">StockFish 10</span>

    <div id="engineLine"
         style="overflow-y: scroll;width: 100% ; font-weight: bold ; color: black;margin-bottom: 5px;margin-top: 5px"
         v-html="line" @click='onMoveClick($event)'>
    </div>
    <div v-html="lineStats">
    </div>
  </div>
</template>

<script>

    import Chess from 'chess.js'

    export default {
        name: "engine",
        data() {
            return {
                engineSwitch: "Off",
                fen: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
                lineInfo: {},
                line: '',
                lineStats: '',
                switch2: false,
                myOptions: {
                    layout: {
                        color: 'black',
                        backgroundColor: 'lightgray',
                        selectedColor: 'white',
                        selectedBackgroundColor: 'green',
                        borderColor: 'black',
                        fontFamily: 'Arial',
                        fontWeight: 'normal',
                        fontWeightSelected: 'bold',
                        squareCorners: false,
                        noBorder: true
                    },
                    size: {
                        fontSize: 0.7,
                        height: 1.7,
                        padding: 0.3,
                        width: 5
                    },
                    items: {
                        delay: .4,
                        preSelected: 'unknown',
                        disabled: false,
                        labels: [
                            {name: 'Off', color: 'white', backgroundColor: 'gray'},
                            {name: 'On', color: 'white', backgroundColor: 'green'}
                        ]
                    }
                }
            }
        },
        props: {
            data: {
                type: String,
                required: false
            }
        },
        methods: {
            manualEngineSwitch(value){
                this.engineSwitch = value;
                this.onEngineSwitch(value);
            },
            onEngineSwitch(value) {

                if (value === "On") {
                    this.startEngine();
                } else {
                    this.uciCommand("stop");
                }
            },
            uciCommand(cmd) {
                // console.log("uci cmd: " + cmd);
                this.engine.postMessage(cmd);
            },
            parseEngineLine(lineInfo) {
                let tokens = lineInfo.split(' ');
                let info = {};

                for (var i = 0; i < tokens.length; i++) {
                    let token = tokens[i].trim();

                    if (token === "info")
                        continue;

                    if (token === "depth") {
                        info.depth = parseInt(tokens[i + 1]);
                    } else if (token === "currmove") {
                        info.currMove = tokens[i + 1];
                    } else if (token === "currmovenumber") {
                        info.currMoveNumber = parseInt(tokens[i + 1]);
                    } else if (token === "seldepth") {
                        info.selDepth = parseInt(tokens[i + 1]);
                    } else if (token === "multipv") {
                        info.pvIndex = parseInt(tokens[i + 1]);
                    } else if (token === "score") {
                        info.scoreType = tokens[i + 1];
                        info.scoreValue = parseInt(tokens[i + 2]);
                    } else if (token === "nodes") {
                        info.nodes = +tokens[i + 1];
                    } else if (token === "nps") {
                        info.nps = +tokens[i + 1];
                    } else if (token === "tbhits") {
                        info.tbHits = +tokens[i + 1];
                    } else if (token === "time") {
                        info.time = +tokens[i + 1];
                    } else if (token === "pv") {
                        var sb = "";

                        for (var x = i + 1; x < tokens.length; x++) {
                            sb = sb + tokens[x] + " ";
                        }

                        info.pv = sb.trim();

                        break;
                    }
                }

                return info;
            },
            onEngineMessage(line) {

                if (typeof line.data == "string" && line.data.length > 0) {
                    let tokens = line.data.split(" ");
                    // console.log("UCI <- {}", tokens[0]);

                    switch (tokens[0].trim()) {
                        case 'uciok':
                            this.uciCommand("isready");
                            return;
                        case 'info':
                            this.infoLine = this.parseEngineLine(line.data);
                            // console.log(this.infoLine);
                            if (this.engineSwitch === "On") {
                                this.updatePV(this.infoLine);
                            }

                            return;
                        case 'bestmove':
                            // console.log(line.data);

                            if (this.engineSwitch === "On") {
                                let parts = line.data.split(" ");
                                let ponder = line.data.indexOf("ponder");
                                this.infoLine.bestMove = parts[1].trim();

                                if (ponder !== -1) {
                                    this.infoLine.ponder = parts[3];
                                }

                                // console.log(this.infoLine);
                                this.updatePV(this.infoLine);
                            }


                            this.engineSwitch = "Off";
                            // console.log(this.chess.history({verbose: true}));

                            return;
                    }
                }
            },
            updatePV(lineInfo) {
                if (lineInfo.pv) {
                    this.chess.load(this.fen);
                    this.lineStats = this.infoLineStats(lineInfo, this.chess.turn());
                    let evaluation = parseFloat(lineInfo.scoreValue) / 100;
                    var humanEval = '';

                    if (lineInfo.scoreType === 'mate') {
                        humanEval = "#";
                    } else {
                        humanEval = this.getHumanEvaluation(evaluation.toFixed(2), this.chess.turn());
                    }

                    let moves = lineInfo.pv.split(" ");

                    for (var y = 0; y < moves.length; y++) {
                        this.chess.move(moves[y], {sloppy: true});
                    }

                    let pgnLine = this.toPGN();

                    this.line = "(" + humanEval + ") " + pgnLine;
                }
            },
            toPGN() {
                var reversed_history = [];

                while (this.chess.history().length > 0) {
                    reversed_history.push(this.chess.undo());
                }

                var moves = [];
                var move_string = '';

                /* build the list of moves.  a move_string looks like: "3. e3 e6" */
                while (reversed_history.length > 0) {
                    var move = reversed_history.pop();
                    var cFen = this.chess.fen();
                    var tokens = cFen.split(/\s+/);
                    var move_number = parseInt(tokens[5], 10);

                    /* if the position started with black to move, start PGN with 1. ... */
                    if (!this.chess.history().length && move.color === 'b') {
                        move_string = move_number + '. ...';
                    } else if (move.color === 'w') {
                        if (move_string.length) {
                            moves.push(move_string);
                        }
                        move_string = move_number + '.';
                    }

                    this.chess.move(move);
                    move_string = move_string + ' <a href="=' + this.chess.fen() + '">' + move.san + '</a>';
                }

                /* are there any other leftover moves? */
                if (move_string.length) {
                    moves.push(move_string);
                }

                return moves.join(' ');
            },
            onMoveClick(event) {
                event.preventDefault();
                var href = decodeURIComponent(event.target.href);
                href = href.substring(href.indexOf("=") + 1);
                this.$emit("setFen", href);
                this.fen = href;
            },
            setFEN(fen) {
                this.fen = fen;

                // console.log("engine fen "+fen);

                if (this.engineSwitch === "On") {
                    this.startEngine();
                }
            },
            startEngine() {
                this.uciCommand('position fen ' + this.fen);
                this.uciCommand('go infinite');
            },
            stopEngine() {
                // console.log("closing the engine");
                this.uciCommand("stop");
                this.engine.terminate();
            },
            infoLineStats(line) {
                var sb = '';

                if (line.depth) {
                    sb = sb + ' d=' + line.depth;
                }

                if (line.nodes) {
                    sb = sb + ' n=' + this.nodesToString(line.nodes);
                }

                if (line.nps) {
                    sb = sb + " nps=" + this.nodesToString(line.nps);
                }

                if (line.time > 0) {
                    sb = sb + " time:" + parseFloat(line.time / 1000).toFixed(0).toString() + "s";
                }

                return sb;
            },
            getHumanEvaluation(evaluation, colorToMove) {
                var valueOf = evaluation.toString();

                if (colorToMove === 'b') {
                    if (eval < 0) {
                        //white is winning, show +ve sign
                        valueOf = "+" + Math.abs(evaluation).toString();
                    } else {
                        //white is losing, show -ve sign
                        valueOf = "-" + Math.abs(evaluation).toString();
                    }
                }

                return valueOf;
            },
            nodesToString(nodes) {
                if (nodes < 100000) {
                    return nodes;
                } else if (nodes < 1000000) {
                    let temNodes = parseFloat(nodes) / 1000;
                    return temNodes.toFixed(0) + "K";
                } else {
                    let temNodes = parseFloat(nodes) / 1000000;
                    return temNodes.toFixed(2) + "M";
                }
            }
        },
        mounted() {
        },
        created() {
            this.engine = new Worker("engine/stockfish.js");
            this.uciCommand("uci");
            this.engine.onmessage = this.onEngineMessage;
            this.chess = new Chess();
        },
    }
</script>
<style>

</style>
